import React, {Component} from 'react';

import Registry from '../../../registry/index';

import './styles.scss';

const NODE_TEXT = 3;

const KEYCODE_BACKSPACE = 8;
const KEYCCODE_ENTER = 13;
const KEYCODE_DELETE = 46;

const STUB_CHARCODE = 0x2009;

const ATTRIBUTE_BR_OWN = '__chateditor_own';

class ChatEditorOwn extends Component {
    constructor(props) {
        super(props);

        this.state = {
            editorStyle: props.editorStyle
        };

        this._isGecko = navigator.userAgent.match(/Gecko\/|Firefox\//);

        this.sendEnteredMessage = this.sendEnteredMessage.bind(this);
        this.getBbcodeText = this.getBbcodeText.bind(this);
        this.clearEditor = this.clearEditor.bind(this);
        this._handlePaste = this._handlePaste.bind(this);
        this._onKeyDown = this._onKeyDown.bind(this);
        this._onFocusBlur = this._onFocusBlur.bind(this);
        this._onInput = this._onInput.bind(this);
        this._updateStateClass = this._updateStateClass.bind(this);
    }

    _getDefaultSmile() {
        return {
            emoji: '😀',
            code: 'Smile'
        }
    }

    _createSmileNode(smile) {
        var el = document.createElement('u');
        el.innerText = smile.emoji;
        el.contentEditable = false;

        return el;
    }

    _createMentionNode(nick) {
        var el = document.createElement('span');

        // spaces before & after nick
        el.textContent = String.fromCharCode(STUB_CHARCODE);
        el.setAttribute("data-text", ' @'+nick);

        el.contentEditable = false;
        el.className = "mention";
        el.setAttribute("rel", nick);

        return el;
    }

    _isChildNodeOf(childNode, parentNode) {
        if (!childNode || !parentNode) return false;

        var upperLevelNode;
        while (upperLevelNode = childNode.parentNode) {
            if (upperLevelNode === parentNode) return true;
            childNode = upperLevelNode;
        }

        return false;
    }

    _insertEntity(editorEl, entityNode, callback) {
        // todo: use TextNode.splitText() https://developer.mozilla.org/en-US/docs/Web/API/Text/splitText

        var selection = window.getSelection();

        var bNode = selection.baseNode,
            bOffset = selection.baseOffset,
            fNode = selection.focusNode,
            fOffset = selection.focusOffset;

        if (!this._isChildNodeOf(bNode, editorEl) && !this._isChildNodeOf(fNode, editorEl)) {
            editorEl.appendChild(entityNode);
        } else if (selection.isCollapsed) {
            // empty editor
            if (!fNode || fNode == editorEl) {
                editorEl.appendChild(entityNode);
            }
            // text node
            else if (fNode.nodeType == NODE_TEXT) {
                if (fOffset == fNode.length) {
                    var nextNode = fNode.nextSibling;

                    if (nextNode) {
                        fNode.parentNode.insertBefore(entityNode, nextNode)
                    } else {
                        fNode.parentNode.appendChild(entityNode)
                    }

                } else {
                    var fNodeData1 = fNode.textContent.slice(0, fOffset),
                            fNodeData2 = fNode.textContent.slice(fOffset);

                    var fNode1 = document.createTextNode(fNodeData1),
                            fNode2 = document.createTextNode(fNodeData2);

                    fNode.parentNode.insertBefore(fNode2, fNode);
                    fNode.parentNode.insertBefore(fNode1, fNode2);
                    fNode.parentNode.removeChild(fNode);

                    fNode2.parentNode.insertBefore(entityNode, fNode2);
                }
            } else {
                throw Error("Only text nodes are supported now");
            }
        } else {
            // removing all whole intermediate nodes
            for (var iNode = bNode.nextSibling; iNode && (iNode != fNode); iNode = iNode.nextSibling) {
                iNode.parentNode.removeChild(iNode);
            }

            var bNodeData = bNode.textContent.slice(0, bOffset),
                    fNodeData = bNode.textContent.slice(fOffset);

            if (bNode != fNode) {
                bNode.textContent = bNodeData;
                fNode.textContent = fNodeData;

                fNode.parentNode.insertBefore(entityNode, fNode);
            } else {
                var newNode1 = document.createTextNode(bNodeData),
                        newNode2 = document.createTextNode(fNodeData);

                fNode.parentNode.insertBefore(newNode2, fNode);
                fNode.parentNode.insertBefore(entityNode, newNode2);
                fNode.parentNode.insertBefore(newNode1, entityNode);
                fNode.parentNode.removeChild(fNode);
            }

            selection.empty ? selection.empty() : selection.removeAllRanges();
        }

        // todo: replace with mutation observer
        this._updateStateClass('');

        if (typeof callback == "function") callback.call(null, editorEl, entityNode);
    }

    insertSmile(smile) {
        smile = smile || this._getDefaultSmile();
        var smileNode = this._createSmileNode(smile);
        this._insertEntity(this.editorElement, smileNode, function(editorEl, entityNode) {
            let blankNode1 = ChatEditorOwn.getStubNode(),
                blankNode2 = blankNode1.cloneNode(false);

            editorEl.insertBefore(blankNode1, entityNode);

            let nextSibling = entityNode.nextSibling;
            if (nextSibling) {
                editorEl.insertBefore(blankNode2, nextSibling);
            } else {
                editorEl.appendChild(blankNode2);
            }
        });
    }

    insertMention(nick) {
        var mentionNode = this._createMentionNode(nick);
        this._insertEntity(this.editorElement, mentionNode, function(editorEl, entityNode) {
            let blankNode1 = ChatEditorOwn.getStubNode(),
                blankNode2 = blankNode1.cloneNode(false);

            editorEl.insertBefore(blankNode1, entityNode);

            let nextSibling = entityNode.nextSibling;
            if (nextSibling) {
                editorEl.insertBefore(blankNode2, nextSibling);
            } else {
                editorEl.appendChild(blankNode2);
            }
        });
    }

    _getTextContent(node) {
        if (node.nodeType === NODE_TEXT) {
            return node.nodeValue.replace(new RegExp(String.fromCharCode(STUB_CHARCODE), "g"), "");
        } else if (node.tagName === "IMG") {
            return "[IMG]" + node.getAttribute("src") + "[/IMG]";
        } else if (node.tagName === "U") {
            return node.innerText;
        } else if (node.tagName === "SPAN" && node.className === "mention") {
            return "[MENTION]" + node.getAttribute("rel") + "[/MENTION]";
        } else if (node.tagName === "BR") {
            return "\n";
        }

        return "";
    }

    _rgb2hex(rgb){
     rgb = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
     return (rgb && rgb.length === 4) ? "#" +
      ("0" + parseInt(rgb[1],10).toString(16)).slice(-2) +
      ("0" + parseInt(rgb[2],10).toString(16)).slice(-2) +
      ("0" + parseInt(rgb[3],10).toString(16)).slice(-2) : rgb;
    }

    _wrapInStyles(text) {
        var prefix = "",
            suffix = "";

        var editorEl = this.editorElement;
        var style = editorEl.style;

        if (style.fontWeight === "bold") {
            prefix += "[b]";
            suffix = "[/b]" + suffix;
        }

        if (style.fontStyle === "italic") {
            prefix += "[i]";
            suffix = "[/i]" + suffix;
        }

        var fontSizeMatch = style.fontSize.match(/^(\d+)%$/);
        if (fontSizeMatch) {
            prefix += '[size=' + fontSizeMatch[1] + ']';
            suffix = '[/size]' + suffix;
        }

        if (style.fontFamily) {
            var compressedFontFamily = style.fontFamily.match(/^([^,]+)/)[1].replace(/\s/g, '');

            prefix += '[font=' + compressedFontFamily + ']';
            suffix = '[/font]' + suffix;
        }

        if (style.color) {
            prefix += '[color=' + this._rgb2hex(style.color) + ']';
            suffix = '[/color]' + suffix;
        }

        return prefix + text + suffix;
    }

    getBbcodeText(noStyling) {
        noStyling = !!noStyling;

        var editorEl = this.editorElement;
        var nodes = editorEl.childNodes;

        var ret = "";
        for (var i = 0; i < nodes.length; i++) {
            ret += this._getTextContent(nodes[i]);
        }

//        console.log("text", ret);
        ret = ret.replace(new RegExp("[\r\n]+"), "\n");

        if (!ret) return "";

        if (!noStyling) ret = this._wrapInStyles(ret);

        return ret;
    }

    value() {
        return this.getBbcodeText();
    }

    sendEnteredMessage() {
        let formattedText = this.getBbcodeText();
        //console.log("formattedText", formattedText);
        this.props.sendMessageFn(formattedText, this);
    }

    clearEditor() {
        this.editorElement.textContent = '';
    }

    _handlePaste(event) {
        // cancel paste
        event.preventDefault();

        // get text representation of clipboard
        var text = (event.originalEvent || event).clipboardData.getData('text/plain');

        // insert text manually
        document.execCommand("insertHTML", false, text);
    }

    addLineBreak() {
        let brNode = document.createElement('br');
        brNode.setAttribute(ATTRIBUTE_BR_OWN, '1');

        this._insertEntity(this.editorElement, brNode, function (editorEl, insertedNode) {
            if (!insertedNode.nextSibling) {
                var stubNode = ChatEditorOwn.getStubNode();
                editorEl.appendChild(stubNode);
            }
        });

        var range = document.createRange();
        range.setStart(brNode.nextSibling, 0);
        range.collapse(true);

        var selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
    }


    _onKeyDown(event) {
        if (event.ctrlKey) {
            let c = event.keyCode;
            // ctrl+B/I/U
            if (c === 66 || c === 98 || c === 73 || c === 105 || c === 85 || c === 117) {
                event.preventDefault();
                return false;
            }
        }

        if (event.keyCode === KEYCCODE_ENTER) {
            event.preventDefault();

            if (event.ctrlKey) {
                this.addLineBreak();
            } else {
                this.sendEnteredMessage();
            }
        }

        if (event.keyCode === KEYCODE_BACKSPACE) {
            let {focusNode, isCollapsed} = window.getSelection(),
                focusNodePrevSibling = focusNode.previousSibling;

            // todo: remove commented code
            /*
            let focusNodeType = focusNode.nodeType,
                focusNodeTextContent = focusNode.textContent,
                focusNodePrevSiblingTextContent = focusNodePrevSibling.textContent;

            console.log({focusNodeType, focusNodeTextContent, focusNodePrevSiblingTextContent});
            */

            if (isCollapsed &&
                ChatEditorOwn.isStubNode(focusNode) &&
                focusNodePrevSibling &&
                focusNodePrevSibling.className === 'mention'
            ) {
                event.preventDefault();

                this.editorElement.removeChild(focusNode);
                this.editorElement.removeChild(focusNodePrevSibling);
            }
        }

        if (event.keyCode === KEYCODE_DELETE) {
            let {focusNode, focusOffset, } = window.getSelection();

            let textNodeEndIsReached = (ChatEditorOwn.isStubNode(focusNode) && focusOffset === 0) ||
                                       (focusNode.nodeType === NODE_TEXT && focusNode.length === focusOffset);

            if (textNodeEndIsReached && focusNode.nextSibling && focusNode.nextSibling.className === 'mention') {
                event.preventDefault();
                this.editorElement.removeChild(focusNode.nextSibling);
            }
        }
    }

    // todo: replace with component's state-based css class in render()
    _updateStateClass(state) {
        var classesRegexp = /(focus|empty)/;
        this.editorElement.className = this.editorElement.className.replace(classesRegexp, state);
    }

    _onFocusBlur(event) {
        if (event.type == 'focus') {
            this._updateStateClass('focus');
        } else if (event.type == 'blur') {
            if (!this.getBbcodeText(true)) {
                this._updateStateClass('empty');
            }
        }
    }

    _onDrag(event) {
        event.preventDefault();
        return false;
    }

    blur() {
        this.editorElement.blur();
    }

    _onInput() {
        this.props.sendNotifyFn()
    }

    _onInputGecko(event) {
        let editorElement = event.target;
        editorElement.normalize();
    }

    _onBlurGecko(event) {
        let editorElement = event.target;
        for (let index in editorElement.childNodes) {
            let childElement = editorElement.childNodes[index];
            if (childElement.tagName == 'BR' && !childElement.hasAttribute(ATTRIBUTE_BR_OWN)) {
                editorElement.removeChild(childElement);
            }
        }

    }

    componentDidMount() {
        this.editorElement.className += ' empty';

        this.editorElement.addEventListener('paste', this._handlePaste);
        this.editorElement.addEventListener('keydown', this._onKeyDown);
        this.editorElement.addEventListener('focus', this._onFocusBlur);
        this.editorElement.addEventListener('blur', this._onFocusBlur);
        this.editorElement.addEventListener('input', this._onInput);

        if (this._isGecko) {
            this.editorElement.addEventListener('input', this._onInputGecko);
            this.editorElement.addEventListener('blur', this._onBlurGecko);
        }

        let dragEvent;

        for (dragEvent of ['drag', 'dragenter', 'dragleave', 'dragend', 'dragexit', 'drop']) {
            this.editorElement.addEventListener(dragEvent, this._onDrag);
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({editorStyle: nextProps.editorStyle});
    }

    componentWillUnmount() {
        this.editorElement.removeEventListener('paste', this._handlePaste);
        this.editorElement.removeEventListener('keydown', this._onKeyDown);
        this.editorElement.removeEventListener('focus', this._onFocusBlur);
        this.editorElement.removeEventListener('blur', this._onFocusBlur);

        if (this._isGecko) {
            this.editorElement.removeEventListener('input', this._onInputGecko);
            this.editorElement.removeEventListener('blur', this._onBlurGecko);
        }

        let dragEvent;

        for (dragEvent of ['dragenter', 'dragleave', 'dragend', 'dragexit']) {
            this.editorElement.removeEventListener(dragEvent, this._onDrag);
        }
    }

    render() {
        let lang = Registry.get('locale');
        return (
            <div
                contentEditable="true"
                className="chat-editor-own"
                suppressContentEditableWarning
                style={this.state.editorStyle}
                placeholder={lang.placeholder}
                ref={editorElement => this.editorElement = editorElement}
            />
        );
    }
}

ChatEditorOwn.getStubNode = function() {
    return document.createTextNode(String.fromCharCode(STUB_CHARCODE)); // nbsp;
};


ChatEditorOwn.isStubNode = function(node) {
    return (
        (node.nodeType === NODE_TEXT && node.textContent === String.fromCharCode(STUB_CHARCODE)) ||
        (node.nodeType === NODE_TEXT && node.textContent === ' ') // FF
    );
};

export default ChatEditorOwn;


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/ChatEditorOwn/index.js